import { Component,
         OnInit,
         AfterViewInit,
         Renderer,
         Renderer2,
         Input,
         ViewChild,
         ElementRef,
         EventEmitter,
         Output,
         HostListener } from '@angular/core';
import { PlayerService } from '../player.service';
import { MockPipeResolver } from '@angular/compiler/testing';

declare var Module: any;

@Component({
  selector: 'app-discoarm',
  templateUrl: './discoarm.component.html',
  styleUrls: ['./discoarm.component.css']
})
export class DiscoarmComponent implements OnInit, AfterViewInit {

  @ViewChild('arm') arm: ElementRef;
  @ViewChild('disc') disc: ElementRef;
  @Input() loading = true;
  @Input() rpm = 33;
  @Input() play;
  @Input() position;
  mouseIsDownArm = false;
  mouseIsDownDisc = false;
  arm_rotation = 0;
  arm_width = 0;
  arm_height = 0;
  arm_x = 0;
  arm_y = 0;
  arm_anchor_x = 0;
  arm_anchor_y = 0;
  initialDiscWidth = 0;
  scale = 1;
  last_arm_mouse_angle = 0;

  disc_center_x = 0;
  disc_center_y = 0;
  last_disc_mouse_angle = 0;

  disc_rotation = 0;
  clientY = 0;
  clientX = 0;
  discRotationAnimation;
  armRotationAnimation;
  armtoPlaceanimation;
  armtoStartanimation;
  discRunning = false;

  @HostListener('document:mousemove', ['$event'])
  @HostListener('document:touchmove', ['$event'])
    public mouseMove(event) {
    if (event.type === 'mousemove') {
      event.preventDefault();
    }

    if (this.mouseIsDownArm) {

      this.clientX = event.clientX || event.targetTouches[0].clientX;
      this.clientY = event.clientY || event.targetTouches[0].clientY;

      const angleDeg = Math.atan2(this.clientY - this.arm_anchor_y * this.scale, this.clientX - this.arm_anchor_x*this.scale) * 180 / Math.PI;
      let diff = this.last_arm_mouse_angle - angleDeg;
      if (Math.abs(diff) > 180) diff = 0;
      this.last_arm_mouse_angle = angleDeg;
      this.arm_rotation -= diff;
      if (this.arm_rotation < 0) this.arm_rotation = 0;
      if (this.arm_rotation > 44) this.arm_rotation = 44;
      if (isNaN(this.arm_rotation)) {
        this.arm_rotation = 0;
      }
      this.rotateArm(this.arm_rotation);

    } else if (this.mouseIsDownDisc) {
      this.clientX = event.clientX || event.targetTouches[0].clientX;
      this.clientY = event.clientY || event.targetTouches[0].clientY;

      const angleDeg = Math.atan2(this.clientY - this.disc_center_y, this.clientX - this.disc_center_x) * 180 / Math.PI;

      var diff = this.last_disc_mouse_angle - angleDeg;
      if (Math.abs(diff) > 90) diff = 0;

      this.last_disc_mouse_angle = angleDeg;
      this.disc_rotation -= diff;
      if (this.disc_rotation > 360) this.disc_rotation -= 360;
      if (this.disc_rotation < 0) this.disc_rotation += 360;

      // labba med 0.1 och 0.05
      // todo: setSpeed(diff * 0.1, 0.05);
      this.pS.setSpeed(diff * -0.1, 0.05);

      this.rotateDisc(this.disc_rotation);
    }
  }
  @HostListener('document:touchend', ['$event'])
  @HostListener('document:mouseup', ['$event'])
    public mouseUp(event) {
    if (this.mouseIsDownArm === true) {
      if (this.arm_rotation < 9) {
        this.arm_rotation = 0;
        this.rotateArm(this.arm_rotation);
        this.pS.setPosition(0);
      } else {
        const posfactor = (this.arm_rotation - 9) / (44 - 9);
        this.pS.setPosition(posfactor);
        this.pS.setNeedleDown();
        setTimeout( () => {
          if (this.discRunning && this.arm_rotation > 9) {
            this.armAnimation(0);
          }
        }, 100);
      }
    }

    if (this.mouseIsDownDisc) {
      if (this.discRunning) {
        this.pS.setSpeed(this.rpm / 33, 0.2);
      } else {
        this.pS.setSpeed(0, 0.1);
      }
        this.setMotor(this.discRunning);
    }
    this.mouseIsDownArm = false;
    this.mouseIsDownDisc = false;
  }

  constructor(private renderer: Renderer2, private pS: PlayerService) {

    this.pS.play.subscribe((play) => {
      this.setMotor(play);
      this.discRunning = play;
      if (this.arm_rotation === 0 && play) {
        this.armtoPlace(0);
      }
      if (this.arm_rotation > 9 && !play) {
        cancelAnimationFrame(this.armRotationAnimation);
      }

      if (this.arm_rotation > 9 && play) {
        setTimeout(() => {
          this.armAnimation(0);
        }, 0);
      }
    });

    this.pS.rpm.subscribe((rpm) => {
      this.rpm = rpm;
    });

    this.pS.end_of_song.subscribe((end) => {
      cancelAnimationFrame(this.armRotationAnimation);
      this.armtoStart(0);
    });

    this.pS.new_audio.subscribe((audio) => {
      this.pS.setPosition(0);
      this.pS.setNeedleUp();
      this.armtoStart(0);
    });

  }

  ngOnInit() {
    this.disc.nativeElement.addEventListener('touchstart', (evt) => {
      evt.preventDefault();
    }, {
      capture: true,
      passive: false
    });
    this.arm.nativeElement.addEventListener('touchstart', (evt) => {
      evt.preventDefault();
    }, {
      capture: true,
      passive: false
    });
  }

  ngAfterViewInit() {
      this.initialDiscWidth = this.disc.nativeElement.getBoundingClientRect().width;
      setTimeout(() => {
      this.arm_rotation = 0;
      this.disc_rotation = 0;
      this.scale = 1;
      this.initialDiscWidth = this.disc.nativeElement.getBoundingClientRect().width;
      this.arm_width = (this.arm.nativeElement.width);
      this.arm_height = (this.arm.nativeElement.height);
      this.arm_x = (this.arm.nativeElement.x);
      this.arm_y = (this.arm.nativeElement.y);
      this.arm_anchor_x = this.arm_x + this.arm_width * 0.7;
      this.arm_anchor_y = this.arm_y + this.arm_height * 0.3;
      }, 0 );
  }

  public mouseDownArm(event) {
    event.preventDefault();
    cancelAnimationFrame(this.armRotationAnimation);
    this.pS.setNeedleUp();
    this.scale = this.disc.nativeElement.getBoundingClientRect().width / this.initialDiscWidth;
    this.last_arm_mouse_angle = Math.atan2(event.clientY - this.arm_anchor_y*this.scale, event.clientX - this.arm_anchor_x*this.scale) * 180 / Math.PI;
    this.mouseIsDownArm = true;
  }

  public mouseDownDisc(event) {
    event.preventDefault();
     this.disc_center_x = this.disc.nativeElement.getBoundingClientRect().x + (this.disc.nativeElement.getBoundingClientRect().width * 0.5);
     this.disc_center_y = this.disc.nativeElement.getBoundingClientRect().y + (this.disc.nativeElement.getBoundingClientRect().height * 0.5);

    this.setMotor(false);
    this.pS.setSpeed(0, 0.2);
    this.last_disc_mouse_angle = Math.atan2(event.clientY - this.disc_center_y, event.clientX - this.disc_center_x) * 180 / Math.PI;

    this.mouseIsDownDisc = true;
  }

  public touchDownDisc(event) {
    const clientX = event.targetTouches[0].clientX;
    const clientY = event.targetTouches[0].clientY;
    this.disc_center_x = this.disc.nativeElement.getBoundingClientRect().x + (this.disc.nativeElement.getBoundingClientRect().width * 0.5);
    this.disc_center_y = this.disc.nativeElement.getBoundingClientRect().y + (this.disc.nativeElement.getBoundingClientRect().height * 0.5);

    this.setMotor(false);
    this.pS.setSpeed(0, 0.2);

    this.last_disc_mouse_angle = Math.atan2(clientY - this.disc_center_y, clientX - this.disc_center_x) * 180 / Math.PI;
    this.mouseIsDownDisc = true;
  }

  public touchDownArm(event) {
    const clientX = event.targetTouches[0].clientX;
    const clientY = event.targetTouches[0].clientY;

    cancelAnimationFrame(this.armRotationAnimation);
    this.pS.setNeedleUp();
    this.scale = this.disc.nativeElement.getBoundingClientRect().width / this.initialDiscWidth;
    this.last_arm_mouse_angle = Math.atan2(clientY - this.arm_anchor_y * this.scale, clientX - this.arm_anchor_x * this.scale) * 180 / Math.PI;

    this.mouseIsDownArm = true;
  }

  public setMotor(isOn) {
    if (!isOn) {
      cancelAnimationFrame(this.discRotationAnimation);
    } else {
      this.discAnimation(0);
    }
  }

  private rotateArm(deg) {
    const rounded = deg.toFixed(2);
    this.renderer.setStyle(this.arm.nativeElement, 'transform', 'rotate(' + (rounded) + 'deg)');
  }

  private rotateDisc(deg) {
    this.renderer.setStyle(this.disc.nativeElement, 'transform', 'rotate(' + (deg) + 'deg)');
  }

  private discAnimation(time) {

    this.disc_rotation += (1 * this.rpm / 10);
    if (this.disc_rotation > 360) {
      this.disc_rotation -= 360;
    }
    this.rotateDisc(this.disc_rotation);

    this.discRotationAnimation = requestAnimationFrame((timestamp) => this.discAnimation(timestamp));

  }

  private armAnimation(time) {
    const position = Module._getPosition();
    if (this.discRunning && !this.mouseIsDownArm) {
      this.rotateArm( position * (44 - 9 ) + 9);
      this.arm_rotation = position * (44 - 9 ) + 9;
    }
    if ( position.toFixed(2) === '1.00') {
          this.pS.end_of_song.emit(true);
        } else {
    this.armRotationAnimation = requestAnimationFrame((timestamp) => this.armAnimation(timestamp));
    }
  }

  private armtoPlace(time) {
    if (this.arm_rotation < 9) {
      this.arm_rotation = this.arm_rotation + 0.1;
      this.rotateArm(this.arm_rotation);
      this.armtoPlaceanimation = requestAnimationFrame((timestamp) => this.armtoPlace(timestamp));
    } else {
      this.pS.setNeedleDown();
      this.armAnimation(0);
    }
  }

  private armtoStart(time) {
    if (this.arm_rotation > 0) {
      this.arm_rotation = this.arm_rotation - 0.4;
      this.rotateArm(this.arm_rotation);
      this.armtoStartanimation = requestAnimationFrame((timestamp) => this.armtoStart(timestamp));
    } else {
      this.pS.setNeedleUp();
      this.pS.setPosition(0);
      this.arm_rotation = 0;
    }
  }

}




// WEBPACK FOOTER //
// ./src/app/discoarm/discoarm.component.ts